import Vue from "vue"
import Vuex from "vuex"

Vue.use(Vuex);

let cart = window.localStorage.getItem('shopCart')
let user = window.localStorage.getItem('userSettings')

export const store = new Vuex.Store({
    state: {
        cart: cart ? JSON.parse(cart) : [],
        user: user ? JSON.parse(user) : [],
    },
    mutations:{
        saveUserSettings(state){
            localStorage.setItem('userSettings', JSON.stringify(state.user))
        },
        saveCart(state){
            localStorage.setItem('shopCart', JSON.stringify(state.cart))
        },
        addToCart(state, item){

            let productObject = {
                id:item.data.id,
                title: item.data.title ? item.data.title : item.data.name,
                poster_path: item.data.poster_path,
                qty: 1,
                type: item.type,
            }
            let indexOfExistingProduct = state.cart.findIndex(
                (el) => el.id === productObject.id
            );

            //check si id du produit à ajouter est présent dans le panier
            //Si déjà présent, j'incrémente la prop qté
            if(indexOfExistingProduct !== -1) {
                state.cart[indexOfExistingProduct].qty += 1;
            }
            //Si il n'est pas présent, j'ajoute le nouveau produit au tableau Card
            else {
                state.cart.push(productObject);
            }

            this.commit('saveCart');

        },
        DELETE_MOVIE(state, id){
            const index = state.cart.findIndex(
                el => el.id === id
            );

            state.cart.splice(index, 1)

            this.commit('saveCart');
        },

        addUserSettings(state, item){

            let productObject = {
                request_token:item.request_token,
                session_id:item.session_id,
                user_id:item.user_id
            }

            state.cart.push(productObject);
            this.commit('saveUserSettings');
        }
    },
    getters: {
        calcTotalQtyCard: (state) => {
            return state.cart.reduce((total,product) => total + product.qty,0)
        }
    }
})